import axios from "axios";
// Vector Logger API
const axiosInstanceRobot = axios.create({
  baseURL: "https://qo5fx9y335.execute-api.ap-northeast-2.amazonaws.com",
  headers: {
    "Content-Type": "application/json",
    // Include the JWT token in the Authorization header
    // Replace 'token' with the actual token you have stored
    "X-API-Key": "wmkey1",
  },
});

const apiRobot = {
  get(url, params = {}) {
    return axiosInstanceRobot.get(url, { params });
  },
  post(url, data = {}) {
    return axiosInstanceRobot.post(url, data);
  },
  patch(url, data = {}) {
    return axiosInstanceRobot.patch(url, data);
  },
  delete(url) {
    return axiosInstanceRobot.delete(url);
  },
  put(url, data = {}) {
    return axiosInstanceRobot.put(url, data);
  },
};

export default apiRobot;
